import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const referAndEarnApiCall = async ({ token, deviceId, payload }) => {
  try {
    const response = await axios.post(`${BASE_URL}v2/api/`, payload, {
      headers: {
        jwt_token: localStorage.getItem("jwt_token"),
        secret: "a82c780bb6875b487b1efca3dba491da",
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
    return response;
  } catch (error) {
    return error;
  }
};
